<template>
  <div v-if="$parent.form.tipo_geocerca == 1">
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label for="lat">Latitud</label>
          <input
            type="number"
            step="any"
            v-model.number="$parent.form.latitud"
            class="form-control"
            @change="
              searchCenter({
                latitud: $parent.form.latitud,
                longitud: $parent.form.longitud,
              })
            "
          />
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="lng">Longitud</label>
          <input
            type="number"
            step="any"
            v-model.number="$parent.form.longitud"
            class="form-control"
            @change="
              searchCenter({
                latitud: $parent.form.latitud,
                longitud: $parent.form.longitud,
              })
            "
          />
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="color">Color</label>
          <input
            id="color"
            type="color"
            v-model="$parent.form.color"
            class="form-control form-control-sm p-0"
            style="height: 35px; width: 100px;"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 mb-2">
        <button
          type="button"
          class="btn btn-primary"
          @click="addPath()"
          v-if="paths.length == 0"
        >
          Agregar Puntos
        </button>
        <button type="button" class="btn btn-danger" @click="removePath()">
          Eliminar Puntos
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <gmap-map
          :center="center"
          :zoom="17"
          style="width: 100%; height: 400px"
          ref="map"
        >
          <gmap-marker
            :key="index"
            v-for="(m, index) in markers"
            :position="m.position"
            :icon="m.icon"
          ></gmap-marker>
          <gmap-polygon
            v-if="paths.length > 0"
            :paths="paths"
            :editable="true"
            :options="polygonOptions"
            @paths_changed="editarPoligono($event)"
            @rightclick="handleClickForDelete"
            ref="polygon"
          >
          </gmap-polygon>
        </gmap-map>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 mt-4">
        <table
          id="geocercasPoli"
          class="table table-bordered table-striped table-hover table-sm"
        >
          <thead class="thead-dark">
            <tr>
              <th>Posición</th>
              <th>Longitud</th>
              <th>Latitud</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(puntos, index) in paths[0]" :key="puntos.id">
              <td v-text="puntos.posicion ? puntos.posicion : index + 1"></td>
              <td v-text="puntos.lng"></td>
              <td v-text="puntos.lat"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GeocercaMapPoli",
  data() {
    return {
      form: {},
      latitud: null,
      longitud: null,
      center: { lat: 4.651371, lng: -74.071509 },
      markers: [],
      places: [],
      edited: null,
      paths: [],
      mvcPaths: null,
      errorMessage: null,
      polygonGeojson: "",
    };
  },

  watch: {
    polygonPaths: function(paths) {
      if (paths) {
        this.paths = paths;
        this.$parent.form.latitud = this.paths[0][0].lat;
        this.$parent.form.longitud = this.paths[0][0].lng;
        this.$parent.form.detalle_geocerca = this.paths;
      }
    },
  },

  computed: {
    polygonPaths: function() {
      if (!this.mvcPaths) return null;
      let paths = [];
      for (let i = 0; i < this.mvcPaths.getLength(); i++) {
        let path = [];
        for (let j = 0; j < this.mvcPaths.getAt(i).getLength(); j++) {
          let point = this.mvcPaths.getAt(i).getAt(j);
          path.push({
            id: j,
            lat: point.lat(),
            lng: point.lng(),
            posicion: j + 1,
          });
        }
        paths.push(path);
      }
      return paths;
    },
    polygonOptions() {
      const color = this.$parent.form.color || "#000000";
      return {
        fillColor: color,
        fillOpacity: 0.35,
        strokeColor: color,
        strokeWeight: 2,
      };
    },
  },

  methods: {
    searchCenter(event) {
      this.center = {
        lat: parseFloat(event.latitud),
        lng: parseFloat(event.longitud),
      };
      this.$parent.form.latitud = parseFloat(event.latitud);
      this.$parent.form.longitud = parseFloat(event.longitud);
    },

    closeLoop(path) {
      return path.concat(path.slice(0, 1));
    },

    markerSitio() {
      if (this.$parent.form.latitud && this.$parent.form.longitud) {
        this.latitud = this.$parent.form.latitud;
        this.longitud = this.$parent.form.longitud;
      } else if (
        this.$parent.mapCenter.latitud &&
        this.$parent.mapCenter.longitud
      ) {
        this.latitud = this.$parent.mapCenter.latitud;
        this.longitud = this.$parent.mapCenter.longitud;
      } else {
        this.latitud = this.center.lat;
        this.longitud = this.center.lng;
      }
      const marker = {
        lat: parseFloat(this.latitud),
        lng: parseFloat(this.longitud),
      };
    },

    addPath: function() {
      var bounds = this.$refs.map.$mapObject.getBounds();
      var northEast = bounds.getNorthEast();
      var southWest = bounds.getSouthWest();
      var center = bounds.getCenter();
      var degree = this.paths.length + 1;
      var f = Math.pow(0.66, degree);

      var path = [
        {
          lng: center.lng(),
          lat: (1 - f) * center.lat() + f * northEast.lat(),
        },
        {
          lng: (1 - f) * center.lng() + f * southWest.lng(),
          lat: (1 - f) * center.lat() + f * southWest.lat(),
        },
        {
          lng: (1 - f) * center.lng() + f * northEast.lng(),
          lat: (1 - f) * center.lat() + f * southWest.lat(),
        },
      ];

      this.paths.push(path);
      this.$parent.form.latitud = this.paths[0][0].lat;
      this.$parent.form.longitud = this.paths[0][0].lng;
      this.$parent.form.detalle_geocerca = this.paths;
    },

    removePath: function() {
      this.paths.splice(this.paths.length - 1, 1);
      this.$parent.form.latitud = null;
      this.$parent.form.longitud = null;
      this.$parent.form.detalle_geocerca = [];
    },

    editarPoligono: function(mvcPaths) {
      this.mvcPaths = mvcPaths;
    },

    handleClickForDelete($event) {
      if ($event.vertex) {
        this.$refs.polygon.$polygonObject
          .getPaths()
          .getAt($event.path)
          .removeAt($event.vertex);
      }
    },

    readGeojson: function($event) {
      try {
        this.polygonGeojson = $event.target.value;

        var v = JSON.parse($event.target.value);

        this.paths = v.coordinates.map((linearRing) =>
          linearRing
            .slice(0, linearRing.length - 1)
            .map(([lng, lat]) => ({ lat, lng }))
        );

        this.errorMessage = null;
      } catch (err) {
        this.errorMessage = err.message;
      }
    },

    async initPaths() {
      this.paths = [];
      if (
        this.$parent.form.detalle_geocerca !== undefined &&
        this.$parent.form.detalle_geocerca.length > 0
      ) {
        let puntos = this.$parent.form.detalle_geocerca[0];
        let paths = new Array();
        for (let i = 0; i < puntos.length; i++) {
          // Se crean lo puntos iniciales del mapa
          let punto = {
            lat: parseFloat(puntos[i]["latitud"]),
            lng: parseFloat(puntos[i]["longitud"]),
            posicion: parseFloat(puntos[i]["posicion"]),
          };
          paths.push(punto);
        }
        this.paths.push(paths);

        // Se establece el centro del mapa
        this.center = {
          lng: parseFloat(puntos[0]["longitud"]),
          lat: parseFloat(puntos[0]["latitud"]),
        };
      } else if (
        this.$parent.mapCenter.latitud &&
        this.$parent.mapCenter.longitud
      ) {
        // Se establece el centro del mapa
        this.center = {
          lng: this.$parent.mapCenter.longitud,
          lat: this.$parent.mapCenter.latitud,
        };
      }
    },
  },

  mounted() {
    if (!this.$parent.form.color) {
      this.$parent.form.color = "#000000";
    }
    this.markerSitio();
    this.initPaths();
  },
};
</script>
